export var DELETED_ADDRESS_MSG = {
    message: 'Address Deleted',
};
export var ADDED_ADDRESS_MSG = {
    message: 'Address Added',
};
export var EDITED_ADDRESS_MSG = {
    message: 'Changes Saved',
};
export var CHANGES_SAVES_MSG = {
    message: 'Changes Saved',
};
export var PAYPAL_ADDED_MSG = {
    message: 'Account Added',
};
export var INACTIVE_SAVES_MSG = {
    message: 'Card Now Inactive',
};
export var DELETE_GIFT_CARD_MSG = {
    message: 'Gift Card Deleted',
};
export var ACTIVE_SAVES_MSG = {
    message: 'Card Now Active',
};
export var DELETED_CARD_MSG = {
    message: 'Card Deleted',
};
export var ADD_GIFT_CARD = {
    message: 'Gift Card Added',
};
export var CREDIT_CARD_ADDED = {
    message: 'Card Added',
};
export var DELETED_ACCOUNT_MSG = {
    message: 'Checking Account Deleted',
};
export var DELETED_PAYPAL_ACCOUNT_MSG = {
    message: 'Account Deleted',
};
export var STOP_ALL_AUTH_SUCCESS_MSG = {
    message: "You've successfully stopped remote purchase approvals for all credit cards on this account.",
};
export var CARD_PHONE_AUTH_AND_T2C_MSG = {
    message: "You've successfully authorized this card for phone and Text2Confirm purchase approvals.",
};
export var CARD_PHONE_AUTH_MSG = {
    message: "You've successfully authorized this card for phone purchase approvals.",
};
export var CARD_T2C_MSG = {
    message: "You've successfully authorized this card for Text2Confirm purchase approvals.",
};
export var STOPPED_CARD_ALL_AUTH_MSG = {
    message: "You've successfully stopped all remote purchase approvals for this card.",
};
export var STOPPED_CARD_PHONE_AUTH_MSG = {
    message: "You've successfully removed Phone Authorization  for this card.",
};
export var STOPPED_CARD_T2C_MSG = {
    message: "You've successfully stopped Text2Confirm purchase approvals for this card.",
};
export var ADD_KEY_TAG = {
    message: 'Keytag Added',
};
export var DELETED_KEY_TAG = {
    message: 'Keytag Deleted',
};
export var ADD_CHECKING_ACCOUNT = {
    message: 'Checking Account Added',
};
export var DELETED_CITI_CARDS_SUCCESS_MSG1 = {
    message: "You've successfully deleted all credit cards associated with Citi Account ID ****",
};
export var DELETED_CITI_CARDS_SUCCESS_MSG2 = {
    message: ' from your account.',
};
export var EXPORT = {
    message: ' data successfully exported. Please check your downloads folder for the file.',
};
export var PRINT = {
    message: ' data successfully printed. Please check your downloads folder for the file.',
};
